<div class="p-5">
  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-5">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">swap_vert</mat-icon>
        Movimientos Vita
        <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
          {{ total }} en total
        </span>
      </h1>
      <span style="font-size:0.78rem;color:#6b7280;">Payins, payouts, cambios y comisiones de la cuenta Vita (read-only).</span>
    </div>
    <button type="button" (click)="refresh()" [disabled]="loading"
      [style.opacity]="loading ? '0.5' : '1'" [style.cursor]="loading ? 'not-allowed' : 'pointer'"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; margin-top: 8px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
      Actualizar
    </button>
  </div>

  <!-- Filtros -->
  <div class="bg-white p-4 rounded-xl shadow border border-gray-100 mb-5">
    <div class="flex items-center gap-2 mb-3">
      <mat-icon class="text-aguacate-green">filter_list</mat-icon>
      <span style="font-weight:700;color:#1e5a3f;font-size:0.9rem;">Filtros</span>
      <button type="button" (click)="clearFilters()" class="ml-auto"
        style="font-size:0.72rem;font-weight:700;color:#1C593D;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:3px 10px;cursor:pointer;">
        Limpiar
      </button>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <!-- Texto (client-side sobre la página) -->
      <div>
        <label class="mov-lbl">Buscar (en esta página)</label>
        <input type="text" [(ngModel)]="filtroTexto" placeholder="order, email, categoría, Vita ID…" class="mov-input" />
      </div>
      <!-- Categoría -->
      <div>
        <label class="mov-lbl">Categoría / tipo</label>
        <select [(ngModel)]="filtroCategoria" (ngModelChange)="onServerFilterChange()" class="mov-input">
          <option *ngFor="let c of categorias; trackBy: trackByStr" [value]="c">{{ c ? categoriaLabel(c) : 'Todas' }}</option>
        </select>
      </div>
      <!-- Estado -->
      <div>
        <label class="mov-lbl">Estado</label>
        <select [(ngModel)]="filtroEstado" (ngModelChange)="onServerFilterChange()" class="mov-input">
          <option *ngFor="let e of estados" [value]="e.value">{{ e.label }}</option>
        </select>
      </div>
      <!-- Moneda -->
      <div>
        <label class="mov-lbl">Moneda</label>
        <input type="text" [(ngModel)]="filtroMoneda" (ngModelChange)="onServerFilterChange()" placeholder="clp, usd, usdt…" class="mov-input" />
      </div>
      <!-- Source -->
      <div>
        <label class="mov-lbl">Origen</label>
        <select [(ngModel)]="filtroSource" (ngModelChange)="onServerFilterChange()" class="mov-input">
          <option value="">Todos</option>
          <option value="business">Business</option>
          <option value="web">Web</option>
        </select>
      </div>
      <!-- Fecha desde -->
      <div>
        <label class="mov-lbl">Desde</label>
        <input type="date" [(ngModel)]="fechaDesde" (ngModelChange)="onServerFilterChange()" class="mov-input" />
      </div>
      <!-- Fecha hasta -->
      <div>
        <label class="mov-lbl">Hasta</label>
        <input type="date" [(ngModel)]="fechaHasta" (ngModelChange)="onServerFilterChange()" class="mov-input" />
      </div>
      <!-- Orden -->
      <div>
        <label class="mov-lbl">Orden</label>
        <select [(ngModel)]="sort" (ngModelChange)="onServerFilterChange()" class="mov-input">
          <option value="desc">Más recientes</option>
          <option value="asc">Más antiguos</option>
        </select>
      </div>
      <!-- Monto min / max -->
      <div>
        <label class="mov-lbl">Monto mín.</label>
        <input type="number" [(ngModel)]="montoMin" (ngModelChange)="onServerFilterChange()" step="any" class="mov-input" />
      </div>
      <div>
        <label class="mov-lbl">Monto máx.</label>
        <input type="number" [(ngModel)]="montoMax" (ngModelChange)="onServerFilterChange()" step="any" class="mov-input" />
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center py-8"><mat-spinner diameter="28"></mat-spinner></div>

  <div *ngIf="error && !loading" style="background:#fef2f2;border:1px solid #fecaca;border-radius:10px;padding:12px 16px;color:#dc2626;font-size:0.9rem;">
    {{ error }}
  </div>

  <ng-container *ngIf="!loading && !error">
    <div *ngIf="visibleItems.length === 0"
      style="text-align:center;background:#fef3c7;border:1px solid #fde68a;border-radius:10px;padding:16px;color:#92400e;font-weight:600;font-size:0.85rem;">
      No hay movimientos para los filtros seleccionados.
    </div>

    <!-- ═══ Tabla (desktop) ═══ -->
    <div *ngIf="visibleItems.length > 0" class="hidden lg:block overflow-auto border rounded-lg shadow bg-white">
      <table class="w-full" style="border-collapse:collapse;font-size:0.82rem;">
        <thead>
          <tr style="background:#f0fdf4;text-align:left;color:#1e5a3f;">
            <th style="padding:10px 12px;">Fecha</th>
            <th style="padding:10px 12px;">Dirección</th>
            <th style="padding:10px 12px;">Categoría</th>
            <th style="padding:10px 12px;text-align:right;">Monto</th>
            <th style="padding:10px 12px;text-align:right;">Fee</th>
            <th style="padding:10px 12px;">Order</th>
            <th style="padding:10px 12px;">Destino</th>
            <th style="padding:10px 12px;">Estado</th>
            <th style="padding:10px 12px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of visibleItems; trackBy: trackById"
            style="border-top:1px solid #f1f5f9;cursor:pointer;" (click)="openDetalle(t)"
            onmouseover="this.style.background='#f8fafc'" onmouseout="this.style.background='white'">
            <td style="padding:9px 12px;white-space:nowrap;color:#374151;">{{ t.attributes.created_at | date:'dd/MM/yy HH:mm' }}</td>
            <td style="padding:9px 12px;">
              <span *ngIf="direction(t.attributes.category) as d"
                [style.background]="d==='in' ? '#dcfce7' : d==='out' ? '#fee2e2' : '#f1f5f9'"
                [style.color]="d==='in' ? '#15803d' : d==='out' ? '#b91c1c' : '#64748b'"
                style="font-size:0.66rem;font-weight:700;padding:2px 8px;border-radius:999px;">
                {{ dirLabel(t.attributes.category) }}
              </span>
            </td>
            <td style="padding:9px 12px;color:#374151;">{{ categoriaLabel(t.attributes.category) }}</td>
            <td style="padding:9px 12px;text-align:right;font-family:monospace;font-weight:700;color:#1e3a8a;">
              {{ t.attributes.amount }} {{ t.attributes.currency | uppercase }}
            </td>
            <td style="padding:9px 12px;text-align:right;font-family:monospace;color:#6b7280;">{{ t.attributes.total_fee }}</td>
            <td style="padding:9px 12px;font-family:monospace;color:#6b7280;">{{ t.attributes.order || '—' }}</td>
            <td style="padding:9px 12px;color:#2563eb;max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ t.attributes.recipient_email || '—' }}</td>
            <td style="padding:9px 12px;">
              <span [style.background]="statusBg(t.attributes.status)" [style.color]="statusColor(t.attributes.status)"
                style="font-size:0.66rem;font-weight:700;padding:2px 10px;border-radius:999px;">
                {{ statusLabel(t.attributes.status) }}
              </span>
            </td>
            <td style="padding:9px 12px;text-align:right;">
              <mat-icon style="color:#9ca3af;font-size:18px;width:18px;height:18px;">chevron_right</mat-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ═══ Cards (mobile) ═══ -->
    <div *ngIf="visibleItems.length > 0" class="lg:hidden grid grid-cols-1 gap-3">
      <div *ngFor="let t of visibleItems; trackBy: trackById" (click)="openDetalle(t)"
        style="background:white;border:1px solid #e5e7eb;border-radius:12px;padding:12px 14px;cursor:pointer;">
        <div class="flex items-center justify-between mb-1">
          <span [style.background]="direction(t.attributes.category)==='in' ? '#dcfce7' : direction(t.attributes.category)==='out' ? '#fee2e2' : '#f1f5f9'"
            [style.color]="direction(t.attributes.category)==='in' ? '#15803d' : direction(t.attributes.category)==='out' ? '#b91c1c' : '#64748b'"
            style="font-size:0.64rem;font-weight:700;padding:2px 8px;border-radius:999px;">{{ dirLabel(t.attributes.category) }}</span>
          <span [style.background]="statusBg(t.attributes.status)" [style.color]="statusColor(t.attributes.status)"
            style="font-size:0.64rem;font-weight:700;padding:2px 10px;border-radius:999px;">{{ statusLabel(t.attributes.status) }}</span>
        </div>
        <div style="font-family:monospace;font-weight:800;color:#1e3a8a;font-size:1rem;">{{ t.attributes.amount }} {{ t.attributes.currency | uppercase }}</div>
        <div style="font-size:0.74rem;color:#374151;">{{ categoriaLabel(t.attributes.category) }}</div>
        <div style="font-size:0.7rem;color:#6b7280;margin-top:2px;">{{ t.attributes.created_at | date:'dd/MM/yy HH:mm' }} · {{ t.attributes.order || '—' }}</div>
      </div>
    </div>

    <!-- ═══ Paginación server-side ═══ -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4">
      <div style="font-size:0.78rem;color:#6b7280;">{{ rangeLabel }}</div>
      <div class="flex items-center gap-2">
        <label style="font-size:0.74rem;color:#6b7280;">Por página</label>
        <select [(ngModel)]="count" (ngModelChange)="onPageSizeChange()" class="mov-input" style="width:auto;padding:6px 10px;">
          <option *ngFor="let s of pageSizeOptions" [value]="s">{{ s }}</option>
        </select>
        <button type="button" (click)="goPage(page - 1)" [disabled]="page <= 1"
          [style.opacity]="page <= 1 ? 0.4 : 1" class="mov-pg">‹</button>
        <span style="font-size:0.78rem;font-weight:700;color:#374151;">{{ page }} / {{ totalPages }}</span>
        <button type="button" (click)="goPage(page + 1)" [disabled]="page >= totalPages"
          [style.opacity]="page >= totalPages ? 0.4 : 1" class="mov-pg">›</button>
      </div>
    </div>
  </ng-container>
</div>
